import React from "react";
import styles from "./input.module.css";

const TextAreaCustom = ({ label, placeholder, name, formikHandler , formikErrors , formikErrorsName }) => {
  return (
    <div className={styles.inputWrap}>
      <label className={styles.label}>{label}</label>
      <textarea
        name={name}
        className={formikErrors ? styles.inputError : styles.input}
        placeholder={placeholder}
        {...formikHandler}
      ></textarea>
      {formikErrors && <p className={styles.errorText}>{formikErrorsName}</p>}
    </div>
  );
};

export default TextAreaCustom;
